export const TOKEN_KEY = 'ninja_access_token';
export const USER_KEY = 'user';
export const COOKIE_DOMAIN = '.ninjavan.co';
export const AUTH_HOST = 'https://api-qa.ninjavan.co/global/aaa/1.0/google-oauth2';
export const PUBLIC_URL = 'https://storybooks-qa.ninjavan.co'



// WEBPACK FOOTER //
// ./src/constants.js